// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewBankDetails_scrollable-content__Mlpk8","card":"ViewBankDetails_card__axfEv","ant-card-head-title":"ViewBankDetails_ant-card-head-title__bkx3K"};